import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup
} from '@angular/forms';
import { FormStateService } from '../form-state.service';
import { ServiceProviderService } from '../../../../Service/Service-providers/service-provider.service';

@Component({
  selector: 'app-brand-details',
  templateUrl: './brand-details.component.html',
  styleUrls: ['./brand-details.component.scss'],
})
export class BrandDetailsComponent implements OnInit, OnDestroy {
  @Output() nextSection = new EventEmitter<void>();
  form: FormGroup;
  makers: any[] = [];
  filteredMakers: any[] = [];
  checkboxControls: { [key: number]: FormControl } = {};
  searchQuery = '';
  formSubmitted = false;

  constructor(
    private api: ServiceProviderService,
    private formStateService: FormStateService,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({});
  }

  ngOnInit(): void {
    this.api.getVehicleMakers('').subscribe((makers: any[]) => {
      this.makers = makers;
      this.filteredMakers = [...this.makers];

      const savedIds = this.formStateService.getBrandIds() || [];

      for (const maker of this.makers) {
        const isChecked = savedIds.includes(maker.vehicleMakerId);
        const control = new FormControl(isChecked);
        this.checkboxControls[maker.vehicleMakerId] = control;
        this.form.addControl('brand_' + maker.vehicleMakerId, control);
      }
    });
  }

  ngOnDestroy(): void {
    this.saveFormData();
  }

  onSearchChange() {
    const query = this.searchQuery.toLowerCase();
    this.filteredMakers = this.makers.filter((m) =>
      m.name.toLowerCase().includes(query)
    );
  }

  onCheckboxChange(brandId: number, isChecked: boolean) {
    this.checkboxControls[brandId].setValue(isChecked);
  }

  getSelectedBrandIds(): number[] {
    return Object.keys(this.checkboxControls)
      .filter(key => this.checkboxControls[+key].value)
      .map(id => +id);
  }

  get showError(): boolean {
    const selected = Object.values(this.checkboxControls)
      .some(control => control.value === true);
    return !selected && this.formSubmitted;
  }

 onSubmit() {
  this.formSubmitted = true;

  const selected = Object.values(this.checkboxControls)
    .some(control => control.value === true);

  if (!selected) {
    return;
  }

  // Set the selected brand IDs to the FormStateService
  const selectedBrandIds = this.getSelectedBrandIds();
  this.formStateService.setBrandIds(selectedBrandIds);

  console.log('Selected Makers:', selectedBrandIds);
  this.nextSection.emit();
}
  getSelectedMakers() {
    return Object.keys(this.checkboxControls)
      .filter((key: any) => this.checkboxControls[key].value)
      .map(id => +id);
  }

  saveFormData() {
    const selectedBrandIds = this.getSelectedBrandIds();
    this.formStateService.setFormData('brandIds', { brandIds: selectedBrandIds });
  }

  populate(res: any) {
    const ids = Array.isArray(res.brands) ? res.brands.map((b: any) => b.brandId) : [];
    this.formStateService.setBrandIds(ids);
    for (const id of ids) {
      if (this.checkboxControls[id]) {
        this.checkboxControls[id].setValue(true);
      }
    }
  }
}
